export const nl = {
    nav: {
        dashboard: 'Dashboard',
        quoteManagement: 'Offertes Beheer',
        settings: 'Instellingen',
        surveyManagement: 'Enquête Beheer',
        logout: 'Uitloggen',
        superAdminHQ: 'SuperAdmin HQ',
    },
    dashboard: {
        title: 'Alfresko Executief Analyse Dashboard',
        subtitle: 'Realtime inzichten voor bedrijfsprestaties',
        totalQuotes: 'Totaal Offertes',
        thisMonth: 'Deze Maand',
        monthlyVolume: 'Maandelijks Offertevolume',
        monthlySubtitle: 'Trends en groeipatronen bijhouden',
        noData: 'Geen Gegevens Beschikbaar',
        noDataSubtitle: 'Inzichten worden weergegeven zodra offertes worden gegenereerd',
        analyzing: 'Prestatiegegevens analyseren...',
        tooltipText: 'Deze visualisatie toont trends in het aanmaken van offertes voor snelle identificatie van groeikansen en seizoenspatronen.',
    },
    marketing: {
        title: 'Uw Marketing Link',
        subtitle: 'Deel deze unieke link met uw klanten. Deze is specifiek gebrandmerkt voor uw dealership.',
        copied: 'Link gekopieerd naar klembord!',
    },
    quotes: {
        title: 'Offertes Beheer',
        subtitle: 'Beheer en volg alle klantoffertes op één plek',
        selected: 'geselecteerd',
        total: 'offertes totaal',
        page: 'Pagina',
        of: 'van',
        addManualLead: 'Lead Toevoegen',
        sortBy: 'Sorteren Op',
        filterStatus: 'Filter Status',
        viewDetails: 'Details Bekijken',
        hideDetails: 'Details Verbergen',
        addNotes: 'Notities Toevoegen',
        deleteQuote: 'Offerte Verwijderen',
        sort: {
            nameAZ: '📝 Van A tot Z',
            topPrices: '💶 Hoogste Prijs Eerst',
            newest: '⏳ Nieuwste Eerst',
            byStatus: '🎯 Op Status',
        },
        status: {
            all: 'Alle Statussen',
            PENDING: '⏳ In Afwachting',
            CONTACTED: '📞 Gecontacteerd',
            LEFT_MESSAGE: '💬 Bericht Achtergelaten',
            SURVEY_BOOKED: '📅 Inspectie Gepland',
            SURVEY_COMPLETED: '✏️ Inspectie Voltooid',
            REVISED_ESTIMATE_SENT: '📤 Herziene Schatting Verzonden',
            SALE_AGREED: '🤝 Verkoop Akkoord',
            INVOICED: '🧾 Gefactureerd',
            PAYMENT_RECEIVED: '💰 Betaling Ontvangen',
            ORDERED: '📦 Besteld',
            INSTALLED: '🔧 Geïnstalleerd',
            COMPLETE: '✅ Voltooid',
            APPROVED: '✅ Goedgekeurd',
            REJECTED: '❌ Afgewezen',
        },
        details: {
            customerDetails: 'Klantgegevens',
            configDetails: 'Configuratiedetails',
            quoteDetails: 'Offertedetails',
            customerInfo: 'Klantinformatie',
            postcode: 'Postcode',
            size: 'Afmeting',
            canopy: 'Overkapping',
            roof: 'Dak',
            color: 'Kleur',
            walls: 'Wanden',
            accessories: 'Accessoires',
            budget: 'Budget',
            groundCondition: 'Ondergrond',
            customerNotes: 'Klantnotities',
            na: 'N.v.t.',
            none: 'Geen',
        },
        deleteDialog: {
            title: 'Offerte Verwijderen',
            body: 'Wilt u deze offerte verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
            cancel: 'Annuleren',
            confirm: 'Verwijderen',
        },
        statusDialog: {
            title: 'Status Wijzigen',
            body: 'Wilt u de status wijzigen naar',
            body2: 'Deze actie zal de offertstatus bijwerken.',
            cancel: 'Annuleren',
            confirm: 'Bevestigen',
        },
        manualDialog: {
            title: 'Bestaande Lead Toevoegen',
            customerName: 'Klantnaam',
            email: 'E-mail',
            phone: 'Telefoon',
            address: 'Adres',
            addressPlaceholder: 'Straat, Stad, Postcode',
            productType: 'Producttype',
            estimatedValue: 'Geschatte Waarde',
            notes: 'Specificatienotities',
            notesPlaceholder: 'bijv. 3000mm x 2500mm, Antraciet Grijs. Inclusief 2x Verwarmers en LED-verlichting.',
            notesHelper: 'Voer hier afmetingen, kleuren en accessoires in.',
            cancel: 'Annuleren',
            save: 'Lead Opslaan',
            saving: 'Opslaan...',
            products: {
                wallMounted: 'Overkapping - Wandgemonteerd',
                freeStanding: 'Overkapping - Vrijstaand',
                bespoke: 'Anders / Op Maat',
            },
        },
        success: {
            deleted: 'Offerte succesvol verwijderd',
            statusUpdated: 'Status succesvol bijgewerkt!',
            leadAdded: 'Lead succesvol toegevoegd!',
        },
        survey: {
            noSurvey: 'Geen inmeting (enquête) ingediend',
            sectionTitle: 'Voltooide Inmetingsgegevens',
            submittedAt: 'Ingediend op',
        },
    },
    settings: {
        title: 'Instellingen',
        subtitle: 'Beheer uw account',
        nav: {
            users: 'Gebruikersbeheer',
            products: 'Productcatalogus',
            profile: 'Bedrijfsprofiel',
            security: 'Beveiliging',
        },
        users: {
            title: 'Teamleden',
            inviteUser: 'Gebruiker Uitnodigen',
            tableUser: 'Gebruiker',
            tableEmail: 'E-mail',
            tableRole: 'Rol',
            tableActions: 'Acties',
            changeRole: 'Rol Wijzigen',
            removeUser: 'Gebruiker Verwijderen',
            roleAdmin: 'Beheerder',
            roleMember: 'Lid',
        },
        products: {
            title: 'Productcatalogus',
            tabs: {
                baseConfigs: 'Basisconfiguraties',
                walls: 'Wanden',
                accessories: 'Accessoires',
            },
            tableName: 'Naam',
            tableAlias: 'Alias/Componenten',
            tablePrice: 'Prijs',
            tableActions: 'Acties',
            updatePrice: 'Prijs Bijwerken',
        },
        profile: {
            title: 'Bedrijfsprofiel',
            identity: 'Identiteit',
            legalName: 'Juridische Naam',
            brandName: 'Merknaam',
            contact: 'Contact',
            phone: 'Telefoon',
            website: 'Website',
            address: 'Adres',
            financial: 'Financieel',
            vatId: 'BTW-nummer',
            currency: 'Valuta',
            saveChanges: 'Wijzigingen Opslaan',
            logo: 'Logo',
            uploadLogo: 'Logo Uploaden',
        },
        priceEditor: {
            title: 'Prijs Bijwerken',
            body: 'Voer nieuwe prijs in voor',
            front: 'Voorkant',
            sides: 'Zijkanten',
            cancel: 'Annuleren',
            save: 'Opslaan',
        },
        invite: {
            title: 'Gebruiker Uitnodigen',
            name: 'Naam',
            email: 'E-mail',
            password: 'Wachtwoord',
            tooWeak: 'Te zwak',
            cancel: 'Annuleren',
            invite: 'Uitnodigen',
            inviting: 'Verzenden...',
        },
    },
    login: {
        title: 'Beheerderstoegang',
        subtitle: 'Veilige authenticatie vereist',
        email: 'E-mailadres',
        password: 'Wachtwoord',
        submit: 'Toegang tot Portaal',
        forgotPassword: 'Wachtwoord vergeten?',
        poweredBy: 'Mogelijk gemaakt door Alfresko AV',
    },
    security: {
        title: 'Beveiligingsinstellingen',
        subtitle: 'Werk uw wachtwoord bij om uw account veilig te houden.',
        currentPassword: 'Huidig Wachtwoord',
        newPassword: 'Nieuw Wachtwoord',
        confirmPassword: 'Bevestig Nieuw Wachtwoord',
        helperText: 'Minimaal 6 tekens',
        updateButton: 'Wachtwoord Bijwerken',
        errorMatch: 'Nieuwe wachtwoorden komen niet overeen.',
        errorLength: 'Wachtwoord moet minimaal 6 tekens bevatten.',
        success: 'Wachtwoord succesvol bijgewerkt! Log uit en opnieuw in.',
    },
};